import { render } from "./OutpostModal.vue?vue&type=template&id=0c3a8cbc&scoped=true"
import script from "./OutpostModal.vue?vue&type=script&lang=js"
export * from "./OutpostModal.vue?vue&type=script&lang=js"

import "./OutpostModal.vue?vue&type=style&index=0&id=0c3a8cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3a8cbc"]])

export default __exports__